import { render } from "./sensor-holdingRegisters-item.vue?vue&type=template&id=cadb4806&scoped=true"
import script from "./sensor-holdingRegisters-item.vue?vue&type=script&lang=js"
export * from "./sensor-holdingRegisters-item.vue?vue&type=script&lang=js"

import "./sensor-holdingRegisters-item.vue?vue&type=style&index=0&id=cadb4806&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cadb4806"]])

export default __exports__